import React from 'react';
import { CheckCircle, Award, Globe, Shield } from 'lucide-react';
import { mockData } from '../mock';

export const Hero = () => {
  return (
    <section id="home" className="hero-section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="display-large mb-4">
              {mockData.hero.title}
            </h1>
            <p className="body-large mb-8">
              {mockData.hero.subtitle}
            </p>
            
            {/* Feature Badges */}
            <div className="feature-badges">
              {mockData.hero.features.map((feature, index) => (
                <div key={index} className="feature-badge">
                  <CheckCircle size={20} className="text-green-600" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>
            
            {/* CTA Buttons */}
            <div className="hero-cta">
              <a href="#contact" className="btn-cta">
                Request Quote
              </a>
              <a href="#products" className="btn-secondary">
                View Products
              </a>
            </div>
          </div>
          
          {/* Trust Indicators */}
          <div className="trust-indicators">
            <div className="trust-item">
              <Award size={32} className="trust-icon" />
              <div>
                <div className="trust-number">15+</div>
                <div className="trust-label">Years Experience</div>
              </div>
            </div>
            <div className="trust-item">
              <Globe size={32} className="trust-icon" />
              <div>
                <div className="trust-number">50+</div>
                <div className="trust-label">Countries Served</div>
              </div>
            </div>
            <div className="trust-item">
              <Shield size={32} className="trust-icon" />
              <div>
                <div className="trust-number">99.8%</div>
                <div className="trust-label">Quality Assurance</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Hero Styles
const styles = `
.hero-section {
  background: var(--bg-page);
  padding: 140px 0 80px 0;
  min-height: 100vh;
  display: flex;
  align-items: center;
}

.hero-content {
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
}

.hero-text {
  max-width: 800px;
  margin: 0 auto;
}

.feature-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  margin-bottom: 48px;
}

.feature-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  background: white;
  padding: 12px 20px;
  border-radius: 25px;
  font-weight: 500;
  color: var(--text-secondary);
  border: 1px solid var(--border-light);
  box-shadow: 0 2px 4px rgba(0, 69, 52, 0.1);
}

.hero-cta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin-bottom: 64px;
}

.trust-indicators {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 32px;
  max-width: 800px;
  margin: 0 auto;
}

.trust-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px;
  background: white;
  border-radius: 20px;
  border: 1px solid var(--border-light);
  box-shadow: 0 2px 8px rgba(0, 69, 52, 0.1);
  transition: transform 0.3s ease;
}

.trust-item:hover {
  transform: translateY(-4px);
}

.trust-icon {
  color: var(--brand-dark);
  flex-shrink: 0;
}

.trust-number {
  font-size: 28px;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1;
}

.trust-label {
  font-size: 14px;
  color: var(--text-light);
  font-weight: 500;
}

@media (max-width: 781px) {
  .hero-section {
    padding: 100px 0 60px 0;
    min-height: auto;
  }
  
  .hero-cta {
    flex-direction: column;
    align-items: center;
  }
  
  .hero-cta .btn-cta,
  .hero-cta .btn-secondary {
    width: 100%;
    max-width: 300px;
  }
  
  .trust-indicators {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .feature-badges {
    gap: 12px;
  }
  
  .feature-badge {
    padding: 10px 16px;
    font-size: 14px;
  }
}
`;

// Inject styles
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}